export default __webpack_public_path__ + "static/media/flag-angola.91027f69.svg";